// CustomerRow.jsx
import React from 'react';
import Classes from './RecordTable.module.css';
import { useNavigate } from 'react-router-dom';
import MoreDropDown from './MoreDropDown';
import DropDown from './StatusDropDown/DropDown';

export default function TableRow({ value }) {
  const navigateTo = useNavigate();

  return (
    <>
      <div className={Classes.customerRow} key={value._id}>
        <div className={`${Classes.rowElem} ${Classes.elem1}`}>
          <h5>{value.Number}</h5>
        </div>

        <div className={`${Classes.rowElem} ${Classes.elem2}`}>
          <DropDown selectedValue={value.Status} isDropDown={false} />
        </div>

        <div className={`${Classes.rowElem} ${Classes.elem3}`}>
          <h5>{value.Total}</h5>
        </div>
        <div className={`${Classes.rowElem} ${Classes.elem4}`}>
          <h5>{value.Created}</h5>
        </div>
        <div className={`${Classes.rowElem} ${Classes.elem5}`}>
          <h5>{value.Paid}</h5>
        </div>
        <div className={`${Classes.rowElem} ${Classes.elem6}`}>
          <MoreDropDown invoice={value.raw} />
        </div>
      </div>

      {/* Mobile */}
      <div className={Classes.customerRowMobile}>
        <div>
          <div className={Classes.mobElem}>
            <h4>Number</h4>
            <h5>{value.Number}</h5>
          </div>
          <div className={Classes.mobElem}>
            <h4>Status</h4>
            <DropDown selectedValue={value.Status} isDropDown={false} />
          </div>
          <div className={Classes.mobElem}>
            <div style={{ marginTop: '5px' }}>
              <button className={Classes.addBtn} onClick={() => navigateTo(`/add-invoice/${value?.raw?.bookingId || ''}`)}>
                <h5>Add invoice</h5>
              </button>
            </div>
          </div>
        </div>

        <div>
          <div className={Classes.mobElem}>
            <h4>Total</h4>
            <h5>{value.Total}</h5>
          </div>
          <div className={Classes.mobElem}>
            <h4>Created</h4>
            <h5>{value.Created}</h5>
          </div>
          <div className={Classes.mobElem}>
            <h4>Paid</h4>
            <h5>{value.Paid}</h5>
          </div>
        </div>

        <MoreDropDown invoice={value.raw} />
      </div>
    </>
  );
}
